import React, { useState, useEffect } from 'react';
import './Account.scss';
import AccountNavigation from './AccountNavigation/AccountNavigation';
import AccountDetails from './AccountDetails/AccountDetails';
import AccountOrders from './AccountOrders/AccountOrders';

const Account = (props) => {
  const [activeSection, setActiveSection] = useState('My Account');
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  useEffect(() => {
    if (window.location.href.indexOf('#history') > -1) {
      setActiveSection('Order History');
    }
  });

  return (
    <div className="c-account background-color-gray">
      <div className="c-account__wrapper">
        <AccountNavigation
          {...props}
          setActiveSection={setActiveSection}
          activeSection={activeSection}
          setIsOpenMenu={setIsOpenMenu}
          isOpenMenu={isOpenMenu}
        />
        <div className="c-account__content">
          <AccountDetails {...props} activeSection={activeSection} />
          <AccountOrders {...props} activeSection={activeSection} />
        </div>
      </div>
    </div>
  );
};

export default Account;
